import { generateSouthAfricanMSISDN } from '@/functions/generateMsisdn';

export const brandConfigObjectMap = new Map();

export const Brands = {
  MTNNigeriaEn: 'mtn-ng-en',
  UpstreamAISTh: 'ais-th',
  DemoEn: 'demo-en',
  TelkomWorldPlaySouthAfticaEnglish: 'telkom-wp-za-en',
  MTNWorldPlaySouthAfticaEnglish: 'mtn-wp-za-en',
  WorldPlaySouthAfticaEnglish: 'wp-za-en',
};

brandConfigObjectMap.set(Brands.UpstreamAISTh, {
  baseRoute: '/msisdn',
  productId: 33,
});

brandConfigObjectMap.set(Brands.MTNNigeriaEn, {
  baseRoute: '/login',
  productId: 30,
});

brandConfigObjectMap.set(Brands.DemoEn, {
  baseRoute: '/msisdn',
  productId: 57,
  msisdn: parseInt(generateSouthAfricanMSISDN(), 10),
});

brandConfigObjectMap.set(Brands.MTNWorldPlaySouthAfticaEnglish, {
  baseRoute: '/home',
  productId: 57,
});

brandConfigObjectMap.set(Brands.TelkomWorldPlaySouthAfticaEnglish, {
  baseRoute: '/home',
  productId: 60,
});

brandConfigObjectMap.set(Brands.WorldPlaySouthAfticaEnglish, {
  baseRoute: '/home',
  productId: 57,
});
